/**
 * page-preferred-plumbers.js
 * Micron Water Filters — Preferred Plumber Locator
 * Geocodes business addresses via Mapbox — no lat/lng entry needed.
 */
var plumberMap;
var showAllMobile = false;
var hasUserSearched = false;
var MicronPreferredPlumbers = (function () {
  var regionLabels = {
    wa: 'WA', nt: "NT", vic: 'VIC', nsw: 'NSW', qld: 'QLD', sa: 'SA', tas: 'TAS'
  };
  var allPlumbers = [];
  var activeId    = 0;
  var leafletMarkers = [];
  var _mapboxToken = '';
  var _searchDebounce = null;

  function isMobileView() {
    return window.innerWidth <= 768;
  }

function isMapVisible() {
  var mapWrap = document.querySelector('.plumber-map-wrap');
  return mapWrap && mapWrap.style.display !== 'none';
}


  function getPreferredBadge() {
    var section = document.querySelector('.bls__plumber-page');
    if (!section) return '';
    var logo = section.dataset.preferredLogo;
    var w = section.dataset.preferredLogoWidth || 90;
    var h = section.dataset.preferredLogoHeight || 40;
    if (!logo) return '';
    return '<span class="micron-badge">' +
      '<img src="' + logo + '" style="width:' + w + 'px;height:' + h + 'px;object-fit:contain;" />' +
      '</span>';
  }

  // ── Water drop marker element ──────────────────────────────────
  function markerEl(id, isActive, isFeatured) {
    var el = document.createElement('div');
    el.className = 'plumber-marker' + (isActive ? ' plumber-marker--active' : '');
    var size  = isActive ? 32 : 26;
    var color = isFeatured ? '#004e8c' : (isActive ? '#005f94' : '#0077b6');
    el.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + Math.round(size * 1.19) + '" viewBox="0 0 32 38">' +
      '<path d="M16 2C16 2 4 16 4 24C4 31 9.4 36 16 36C22.6 36 28 31 28 24C28 16 16 2 16 2Z" fill="' + color + '" stroke="white" stroke-width="2"/>' +
      (isFeatured ? '<polygon points="16,10 17.5,14.5 22,14.5 18.5,17 19.8,22 16,19.2 12.2,22 13.5,17 10,14.5 14.5,14.5" fill="rgba(255,255,255,0.85)"/>' :
        '<circle cx="11" cy="23" r="3.5" fill="rgba(255,255,255,0.4)"/>') +
      '</svg>';
    return el;
  }

  // ── Popup HTML ─────────────────────────────────────────────────
  function popupHTML(p) {
    return '<div class="plumber-popup js-popup-card" data-id="' + p.id + '">' +
      '<div class="plumber-popup__name">' + p.name + '</div>' +
      '<button class="plumber-popup__lead js-open-lead" ' +
        'data-plumber="' + p.name + '" ' +
        'data-region="' + p.region + '" ' +
        'data-id="' + p.id + '">' +
        'Contact' +
      '</button>' +
    '</div>';
  }

  // ── Build sidebar card HTML ────────────────────────────────────
  function cardHTML(p, distText) {
    var radiusLabel = p.radius >= 9999 ? 'State-wide' : p.radius + ' km radius';
    return '' +
      '<div class="plumber-card__name">' + p.name + '</div>' +
      '<div class="plumber-card__area">' + p.area + '</div>' +
'<div class="plumber-card__row">' +
  '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.09 9.81a19.79 19.79 0 01-3.07-8.57A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.91a16 16 0 006.18 6.18l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>' +
  p.phone +
  (p.url ? 
    ' <a href="' + p.url + '" target="_blank" class="plumber-card__website">View website</a>' 
  : '') +
'</div>' +
      '<div class="plumber-card__row plumber-card__row--radius">' +
        '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>' +
        radiusLabel +
      '</div>' +
      (distText ? '<div class="plumber-card__dist">' + distText + '</div>' : '') +
      '<div class="plumber-card__bottom">' +
        (p.preferred ? getPreferredBadge() : '') +
      '</div>' +
      '<button class="plumber-card__lead-btn js-open-lead" data-plumber="' + p.name + '" data-region="' + p.region + '" data-id="' + p.id + '">Contact Plumber &rarr;</button>';
  }

  // ── Sort: featured first, then by radius descending ────────────
  function sortPlumbers(list) {
    return list.slice().sort(function(a, b) {
      if (a.featured && !b.featured) return -1;
      if (!a.featured && b.featured) return 1;
      return b.radius - a.radius;
    });
  }

  // ── Render sidebar ─────────────────────────────────────────────
function renderSidebar(list, distMap) {
  var container = document.getElementById('plumberList');
  container.innerHTML = '';

  document.getElementById('plumberCount').textContent = list.length;

  var isMobile = window.innerWidth <= 768;
  var limit = (isMobile && !showAllMobile) ? 3 : list.length;

  var visibleList = list.slice(0, limit);

  visibleList.forEach(function(p) {
    var distText = distMap && distMap[p.id] != null
      ? distMap[p.id].toFixed(1) + ' km away'
      : '';

    var div = document.createElement('div');
    div.className =
      'plumber-card' +
      (p.id === activeId ? ' active' : '') +
      (p.featured ? ' plumber-card--featured' : '');

    div.id = 'card-' + p.id;
    div.dataset.id = p.id;
    div.innerHTML = cardHTML(p, distText);

    div.addEventListener('click', function(e) {
      if (!e.target.closest('.js-open-lead') && !e.target.closest('a')) {
        MicronPreferredPlumbers.selectPlumber(p.id);
      }
    });

    container.appendChild(div);
  });

  // Show more button
  if (isMobile && list.length > 3) {
    var btn = document.createElement('button');
    btn.className = 'plumber-show-more';
    btn.textContent = showAllMobile ? 'Showing more plumbers' : 'Show more plumbers';

    btn.addEventListener('click', function() {
      showAllMobile = true;
      renderSidebar(list, distMap);
    });

    container.appendChild(btn);
  }
}
  // ── Render map markers ─────────────────────────────────────────
  function renderMarkers(list) {
    leafletMarkers.forEach(function(m) { m.remove(); });
    leafletMarkers = [];
    list.forEach(function(p) {
      if (p.lat == null || p.lng == null) return;
      var isActive = p.id === activeId;
      var el = markerEl(p.id, isActive, p.featured);
      var marker = new mapboxgl.Marker(el, { offset: [0, -16] })
        .setLngLat([p.lng, p.lat])
        .setPopup(new mapboxgl.Popup({ closeOnClick: false, offset: 28 }).setHTML(popupHTML(p)))
        .addTo(plumberMap);
      if (isActive) setTimeout(function() { marker.togglePopup(); }, 300);
      el.addEventListener('click', function() { MicronPreferredPlumbers.selectPlumber(p.id); });
      leafletMarkers.push(marker);
    });
  }

  // ── Geocode a single address via Mapbox ────────────────────────
  function geocodeAddress(address, token) {
    var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
      encodeURIComponent(address) +
      '.json?access_token=' + token +
      '&country=au&limit=1';
    return fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.features && data.features.length > 0) {
          var coords = data.features[0].geometry.coordinates;
          return { lng: coords[0], lat: coords[1] };
        }
        return null;
      });
  }

  // ── Geocode all plumbers in parallel ──────────────────────────
  function geocodeAll(plumbers, token) {
    var promises = plumbers.map(function(p) {
      return geocodeAddress(p.address || p.name + ' Australia', token)
        .then(function(coords) {
          if (coords) { p.lat = coords.lat; p.lng = coords.lng; }
        })
        .catch(function() {});
    });
    return Promise.all(promises);
  }

  // ── Region email lookup ────────────────────────────────────────
  function getRegionEmail(region) {
    var section = document.querySelector('.bls__plumber-page');
    if (!section) return '';
    var map = {
      wa:  section.dataset.emailWa  || '',
      nt:  section.dataset.emailNt  || '',
      vic: section.dataset.emailVic || '',
      nsw: section.dataset.emailNsw || '',
      qld: section.dataset.emailQld || '',
      sa:  section.dataset.emailSa  || '',
      tas: section.dataset.emailTas || ''
    };
    return map[region] || '';
  }

  // ── Submit via Make webhook ───────────────────────────────────
  function submitToMake(data, onSuccess, onError) {
    var region = (data.region || '').toLowerCase();
    if (region === 'wa_nt') region = 'wa';
    var emailTo = getRegionEmail(region);
    var payload = {
      plumber: data.plumber,
      region: region,
      email_to: emailTo,
      name: data.name,
      phone: data.phone,
      suburb: data.suburb,
      ownership: data.ownership,
      submitted_at: new Date().toISOString()
    };
    fetch('https://hook.eu1.make.com/lun00ny3e82fy6d88e1ed33y4nura3hl', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(res) {
      if (res.ok) onSuccess();
      else onError('Webhook error');
    })
    .catch(function(err) {
      onError(err.toString());
    });
  }

  // ── Haversine ─────────────────────────────────────────────────
  function haversine(lat1, lon1, lat2, lon2) {
    var R = 6371, dLat = (lat2-lat1)*Math.PI/180, dLon = (lon2-lon1)*Math.PI/180;
    var a = Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLon/2)*Math.sin(dLon/2);
    return R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
  }

  // ── Mobile search: inject DOM ─────────────────────────────────
  function injectMobileSearch() {
    var sidebar = document.querySelector('.plumber-sidebar');
    if (!sidebar) return;
    // Don't inject twice
    if (document.getElementById('mobileSearchWrap')) return;

    var wrap = document.createElement('div');
    wrap.className = 'plumber-mobile-search';
    wrap.id = 'mobileSearchWrap';
    wrap.innerHTML =
      '<label class="plumber-mobile-search__label" for="mobileSearchInput">' +
        'Enter your location to find a preferred installer' +
      '</label>' +
      '<div class="plumber-mobile-search__input-wrap">' +
        '<svg class="plumber-mobile-search__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
          '<circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>' +
        '</svg>' +
        '<input type="text" class="plumber-mobile-search__input" id="mobileSearchInput" ' +
          'placeholder="" autocomplete="off" />' +
        '<button class="plumber-mobile-search__clear" id="mobileSearchClear" aria-label="Clear">&times;</button>' +
        '<div class="plumber-mobile-search__suggestions" id="mobileSearchSuggestions"></div>' +
      '</div>' +
      `<div class="plumber-mobile-toggle">
    <button id="toggleList" class="active">List</button>
    <button id="toggleMap">Map</button>
  </div>`
      ;

    // Insert BEFORE the sidebar (so it appears above the list)
    sidebar.parentNode.insertBefore(wrap, sidebar);
bindMobileSearch();

setTimeout(function() {
  var listBtn = document.getElementById('toggleList');
  var mapBtn = document.getElementById('toggleMap');
  var mapWrap = document.querySelector('.plumber-map-wrap');
  var sidebar = document.querySelector('.plumber-sidebar');

  if (!listBtn || !mapBtn || !mapWrap || !sidebar) return;

  listBtn.addEventListener('click', function() {
    listBtn.classList.add('active');
    mapBtn.classList.remove('active');
    sidebar.style.display = 'block';
    mapWrap.style.display = 'none';
  });

  mapBtn.addEventListener('click', function() {
    mapBtn.classList.add('active');
    listBtn.classList.remove('active');
    sidebar.style.display = 'none';
    mapWrap.style.display = 'block';
  });

  // default = list
  mapWrap.style.display = 'none';

}, 50);
  }

  // ── Mobile search: bind events ────────────────────────────────
  function bindMobileSearch() {
    var input = document.getElementById('mobileSearchInput');
    var clearBtn = document.getElementById('mobileSearchClear');
    var suggestionsEl = document.getElementById('mobileSearchSuggestions');
    if (!input) return;

    // Typing → debounce → fetch suggestions
    input.addEventListener('input', function() {
      var val = input.value.trim();
      clearBtn.classList.toggle('visible', val.length > 0);

      if (val.length < 2) {
        suggestionsEl.classList.remove('open');
        suggestionsEl.innerHTML = '';
        return;
      }

      clearTimeout(_searchDebounce);
      _searchDebounce = setTimeout(function() {
        fetchSuggestions(val);
      }, 300);
    });

    // Clear button
    clearBtn.addEventListener('click', function() {
      input.value = '';
      clearBtn.classList.remove('visible');
      suggestionsEl.classList.remove('open');
      suggestionsEl.innerHTML = '';
    });

    // Close suggestions on outside click
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.plumber-mobile-search__input-wrap')) {
        suggestionsEl.classList.remove('open');
      }
    });

    // Re-open on focus if there's content
    input.addEventListener('focus', function() {
      if (suggestionsEl.children.length > 0) {
        suggestionsEl.classList.add('open');
      }
    });
  }



  // ── Mobile search: fetch suggestions from Mapbox ──────────────
  function fetchSuggestions(query) {
    var suggestionsEl = document.getElementById('mobileSearchSuggestions');
    var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
      encodeURIComponent(query) +
      '.json?access_token=' + _mapboxToken +
      '&country=au&types=place,postcode,locality&limit=5' +
      '&bbox=112.9211,-44.3163,154.0031,-9.1422';

    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.features || data.features.length === 0) {
          suggestionsEl.classList.remove('open');
          suggestionsEl.innerHTML = '';
          return;
        }
        suggestionsEl.innerHTML = '';
        data.features.forEach(function(feat) {
          var item = document.createElement('div');
          item.className = 'plumber-mobile-search__suggestion';
          var parts = feat.place_name.split(',');
          var main = parts[0];
          var sub = parts.slice(1).join(',').trim();
          item.innerHTML = '<div>' + main + '</div>' +
            (sub ? '<div class="plumber-mobile-search__suggestion-sub">' + sub + '</div>' : '');
          item.addEventListener('click', function() {
            var input = document.getElementById('mobileSearchInput');
            input.value = main;
            suggestionsEl.classList.remove('open');
            document.getElementById('mobileSearchClear').classList.add('visible');

            var coords = feat.geometry.coordinates;

            // extract region (state)
            var region = '';
            if (feat.context) {
              var regionObj = feat.context.find(function(c) {
                return c.id.indexOf('region') === 0;
              });
              if (regionObj) {
                region = regionObj.short_code ? regionObj.short_code.split('-')[1] : '';
              }
            }
            if (plumberMap && (!isMobileView() || isMapVisible())) {
              plumberMap.flyTo({ center: coords, zoom: 11 });
            }
            hasUserSearched = true;
            MicronPreferredPlumbers.sortByDistance(coords[1], coords[0], region);
          });
          suggestionsEl.appendChild(item);
        });
        suggestionsEl.classList.add('open');
      })
      .catch(function() {
        suggestionsEl.classList.remove('open');
      });
  }

  return {
    // ── Init ──────────────────────────────────────────────────────
    init: function () {
      var section = document.querySelector('.bls__plumber-page');
      if (!section) return;
      var token     = section.dataset.mapboxToken || '';
      _mapboxToken  = token;
      var centerLat = parseFloat(section.dataset.centerLat || '-31.953');
      var centerLng = parseFloat(section.dataset.centerLng || '115.861');
      var zoom      = parseInt(section.dataset.zoom || '9', 10);

      var dataEl = document.getElementById('plumber-data');
      if (!dataEl) return;
      var rawData;
      try { rawData = JSON.parse(dataEl.textContent); }
      catch(e) { console.error('Plumber data parse error', e); return; }
      rawData.forEach(function(p) {
        p.radius = parseInt(p.radius, 10) || 50;
      });

      // Inject mobile search bar
      if (isMobileView()) {
        injectMobileSearch();
      }

      if (!token) {
        document.getElementById('plumber-map').innerHTML =
          '<div style="display:flex;align-items:center;justify-content:center;height:100%;flex-direction:column;gap:12px;background:#f4f7fb;font-family:system-ui,sans-serif">' +
          '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#0077b6" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/></svg>' +
          '<div style="font-size:15px;font-weight:600;color:#0a2540">Map not configured</div>' +
          '<div style="font-size:13px;color:#6b8299;text-align:center;max-width:280px">Add your Mapbox token in the section settings.</div></div>';
        document.getElementById('plumberLoading').style.display = 'none';
        allPlumbers = sortPlumbers(rawData);
        renderSidebar(allPlumbers, null);
        this.bindUIEvents();
        return;
      }

      mapboxgl.accessToken = token;
      plumberMap = new mapboxgl.Map({
        container: 'plumber-map',
        style: 'mapbox://styles/mapbox/streets-v12',
        center: [centerLng, centerLat],
        zoom: zoom,
      });

      var self = this;
      geocodeAll(rawData, token).then(function() {
        allPlumbers = sortPlumbers(rawData);
        activeId = allPlumbers[0] ? allPlumbers[0].id : 0;
        document.getElementById('plumberLoading').style.display = 'none';
        renderSidebar(allPlumbers, {});
        renderMarkers(allPlumbers);
        self.bindUIEvents();
        self.bindMapEvents(token);
      });
    },

    // ── Bind geocoder + URL param ──────────────────────────────────
    bindMapEvents: function(token) {
      var self = this;
      plumberMap.on('load', function() {
        // Auto-locate on mobile
if (!isMobileView() && navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
        function(pos) {
            var lat = pos.coords.latitude;
            var lng = pos.coords.longitude;
            plumberMap.flyTo({ center: [lng, lat], zoom: 11 });
            hasUserSearched = true;  // ← ADD
            MicronPreferredPlumbers.sortByDistance(lat, lng, '');  // ← ADD

            // prevent scroll jump on mobile
            if (isMobileView()) {
                window.scrollTo({ top: 0, behavior: 'instant' });
            }
        }
    );
}
        // Desktop geocoder (only added on desktop — CSS hides it on mobile anyway)
        if (!isMobileView()) {
          var geocoder = new MapboxGeocoder({
            accessToken: token,
            mapboxgl: mapboxgl,
            countries: 'au',
            bbox: [112.9211, -44.3163, 154.0031, -9.1422],
            flyTo: {
  zoom: 25
},
            types: 'place,postcode,locality',
            placeholder: 'Enter suburb or postcode...',
          });
geocoder.on('result', function(e) {
    if (e.result && e.result.geometry) {
        var c = e.result.geometry.coordinates;
        var region = '';
        if (e.result.context) {
            var regionObj = e.result.context.find(function(c) {
                return c.id.indexOf('region') === 0;
            });
            if (regionObj) {
                region = regionObj.short_code ? regionObj.short_code.split('-')[1] : '';
            }
        }
        plumberMap.flyTo({ center: c, zoom: 11 });
        hasUserSearched = true;  // ← ADD THIS
        self.sortByDistance(c[1], c[0], region);
    }
});
          plumberMap.addControl(geocoder, 'top-left');
        }

// URL param ?suburb=.
var suburbParam = new URLSearchParams(window.location.search).get('suburb');
if (suburbParam) {
    // Fill mobile search if present
    var mInput = document.getElementById('mobileSearchInput');
    if (mInput) mInput.value = decodeURIComponent(suburbParam);
    // Fill desktop geocoder if present
    var dInput = document.querySelector('.mapboxgl-ctrl-geocoder input');
    if (dInput) dInput.value = decodeURIComponent(suburbParam);

    fetch('https://api.mapbox.com/geocoding/v5/mapbox.places/' + encodeURIComponent(suburbParam) + '.json?access_token=' + token + '&country=au&types=postcode,place')
        .then(function(r) { return r.json(); })
        .then(function(data) {
            if (data.features && data.features.length > 0) {
                var c = data.features[0].geometry.coordinates;
                plumberMap.flyTo({ center: c, zoom: 11 });
                hasUserSearched = true;  // ← ADD THIS
                self.sortByDistance(c[1], c[0], '');
            }
        });
}
      });
    },

    // ── Select a plumber ──────────────────────────────────────────
selectPlumber: function(id) {
  activeId = id;
  renderMarkers(allPlumbers);

  var p = allPlumbers.find(function(x) { return x.id === id; });

  if (p && p.lat != null && plumberMap) {
    if (!isMobileView()) {
      plumberMap.flyTo({ center: [p.lng, p.lat], zoom: Math.max(plumberMap.getZoom(), 12) });
    }
  }

  document.querySelectorAll('.plumber-card').forEach(function(c) {
    c.classList.remove('active');
  });

  var card = document.getElementById('card-' + id);
  if (card) {
    card.classList.add('active');
    if (!isMobileView()) {
      card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }
},

sortByDistance: function(userLat, userLng, region) {
    if (!hasUserSearched) return;
    var distMap = {};

    allPlumbers.forEach(function(p) {
        if (p.lat != null) {
            distMap[p.id] = haversine(userLat, userLng, p.lat, p.lng);
        }
    });

    // Sort all plumbers by distance — closest first
    var sorted = allPlumbers.slice().sort(function(a, b) {
        return (distMap[a.id] || 9999) - (distMap[b.id] || 9999);
    });

    activeId = sorted[0] ? sorted[0].id : 0;

    renderSidebar(sorted, distMap);
    renderMarkers(sorted);

    if (plumberMap && (!isMobileView() || isMapVisible())) {
        plumberMap.flyTo({ center: [userLng, userLat], zoom: 11 });
    }
},
    // ── UI event bindings ──────────────────────────────────────────
    bindUIEvents: function() {
      var self = this;

      // Open contact modal
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.js-open-lead');
        if (!btn) return;
        e.preventDefault();
        var name   = btn.dataset.plumber || 'Preferred Plumber';
        var region = btn.dataset.region  || 'wa';
        document.getElementById('leadModalPlumber').textContent = name;
        document.getElementById('leadPlumberName').value = name;
        document.getElementById('leadPlumberId').value   = btn.dataset.id || '';
        document.getElementById('leadRegion').value      = region;
        document.getElementById('leadFormWrap').style.display = 'block';
        document.getElementById('leadSuccess').style.display  = 'none';
        document.getElementById('lName').value = '';
        document.getElementById('lPhone').value = '';
        document.getElementById('lSuburb').value = '';
        document.querySelectorAll('[name="ownership"]').forEach(function(el) {
                  el.checked = false;
                });
                var sendBtn = document.querySelector('#leadFormWrap .plumber-btn--send');
                if (sendBtn) {
                    sendBtn.dataset.submitting = '';
                    sendBtn.textContent = 'Send enquiry';
                    sendBtn.disabled = false;
                }
                self.openModal('leadModal');
      });

      // Clicking popup scrolls to card
      document.addEventListener('click', function(e) {
        var popup = e.target.closest('.js-popup-card');
        if (!popup) return;
        if (e.target.closest('.js-open-lead')) return;
        var id = parseInt(popup.dataset.id);
        MicronPreferredPlumbers.selectPlumber(id);
        var card = document.getElementById('card-' + id);
        if (card) {
          if (!isMobileView()) {
  card.scrollIntoView({ block: 'center', behavior: 'smooth' });
}
        }
      });

      // Close modals
      document.addEventListener('click', function(e) {
        if (e.target.closest('.js-close-lead')) self.closeModal('leadModal');
        if (e.target.closest('.js-close-reg'))  self.closeModal('regModal');
        if (e.target.closest('.js-open-reg'))   { e.preventDefault(); self.openModal('regModal'); }
      });
      ['leadModal','regModal'].forEach(function(id) {
        document.getElementById(id).addEventListener('click', function(e) {
          if (e.target.id === id) self.closeModal(id);
        });
      });

      // Lead submit
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.plumber-btn--send');
  if (!btn) return;

  if (btn.dataset.submitting === 'true') return;

  e.preventDefault();

  var ownershipEl = document.querySelector('[name=ownership]:checked');
  if (!ownershipEl) {
    alert('Please select whether you own or rent your home.');
    return;
  }

  var data = {
    plumber:   document.getElementById('leadPlumberName').value,
    region:    document.getElementById('leadRegion').value,
    name:      document.getElementById('lName').value,
    phone:     document.getElementById('lPhone').value,
    suburb:    document.getElementById('lSuburb').value,
    ownership: ownershipEl.value,
  };


  btn.dataset.submitting = 'true';
  btn.textContent = 'Sending...';
  btn.disabled = true;

  submitToMake(data,
    function() {
      document.getElementById('leadFormWrap').style.display = 'none';
      document.getElementById('leadSuccess').style.display  = 'block';
    },
    function() {
      document.getElementById('leadFormWrap').style.display = 'none';
      document.getElementById('leadSuccess').style.display  = 'block';
    }
  );
});

      // Reg submit
      document.getElementById('regForm').addEventListener('submit', function(e) {
        e.preventDefault();
        self.closeModal('regModal');
        alert('Unit registered!\n\nMicron will send annual filter renewal reminders automatically.');
        document.getElementById('regForm').reset();
      });
    },

    openModal: function(id) {
      var el = document.getElementById(id);
      el.style.display = 'flex';
      el.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
    },
    closeModal: function(id) {
      var el = document.getElementById(id);
      el.style.display = 'none';
      el.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
    },
  };
})();

document.addEventListener('DOMContentLoaded', function() { MicronPreferredPlumbers.init(); });